// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ffa59f1c","703":"da7b049d","787":"c75481a1"}[chunkId] + ".chunk.js";
};